/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */

import vasActivationModalTemplate from '../SavedWithSuccessModal.html';
import suggestToMakeMenuTemplate from '../SuggestToMakeMenuModal.html';


class orderAndPayController {

  /* @ngInject */

  constructor($log, $q, $timeout, MerchantConfigurationService,
              MerchantVasService, $rootScope, ModalFactory,
              TermsService, NewTokenService, StorageService, CatalogService) {
    const that = this;
    that.currentVasTypeId = MerchantVasService.getVasesTypes()['ORDER-AT-TABLE'];
    that.currentWalletId = NewTokenService.getMerchantWalletID();
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    that.vasMenus = {};

    this.showVasConfigurationMenuError = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: suggestToMakeMenuTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    this.showVasConfigurationSuccess = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: vasActivationModalTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    that.save = () => {
      MerchantVasService.configureVas( that.currentVas.configuration, that.currentVas.id).then((ok) => {
        that.currentVas.configuration = ok.data;
        that.showVasConfigurationSuccess();
      });
    };

    that.fillMenus = () => {

      CatalogService.getMenus().then((data) => {

        that.vasMenus = data;
        if (!that.vasMenus || that.vasMenus.length === 0) that.showVasConfigurationMenuError();

      });

    };

    const init = () => {
      that.fillMenus();
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
          },
          (error) => {
            alert('error retrieving the vas!');
          }
        );
    };

    that.$onInit = init;
  }

}

export default orderAndPayController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAtTable/orderAtTable.controller.js
 **/